import React, { useState, useEffect } from "react";
import { MessageSquare, Send, Clock } from "lucide-react";
import { callBackend } from "../utils/api";

export default function Mailbox({ onOpenChat, onComposeNew }) {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    callBackend("/social/conversations")
      .then(setConversations)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-zinc-950 border-2 border-zinc-800 p-6 font-mono h-full">
      <div className="flex justify-between items-center border-b border-zinc-800 pb-4 mb-6">
        <h3 className="text-blue-500 font-black uppercase italic flex items-center gap-2">
          <MessageSquare size={20} /> Encrypted Pager (Inbox)
        </h3>
        <button
          onClick={onComposeNew}
          className="bg-blue-600 hover:bg-blue-500 text-black px-4 py-1 text-[10px] font-black uppercase flex items-center gap-2"
        >
          <Send size={12} /> New Transmission
        </button>
      </div>

      <div className="space-y-2 overflow-y-auto max-h-[500px] pr-2">
        {conversations.length === 0 && !loading && (
          <p className="text-center text-zinc-600 italic py-12 text-xs">
            Pager is silent. No active communications.
          </p>
        )}

        {conversations.map((convo) => (
          <div
            key={convo.id}
            onClick={() => onOpenChat(convo)}
            className={`bg-black border p-4 flex justify-between items-center cursor-pointer transition-all hover:bg-zinc-900 ${
              convo.unread_count > 0 ? "border-blue-500" : "border-zinc-900"
            }`}
          >
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-white font-black uppercase text-sm">
                  {convo.username}
                </span>
                {convo.unread_count > 0 && (
                  <span className="bg-blue-600 text-black text-[9px] px-1.5 font-black rounded-sm animate-pulse">
                    {convo.unread_count} NEW
                  </span>
                )}
              </div>
              <p className="text-zinc-500 text-[10px] truncate uppercase">
                {convo.last_message}
              </p>
            </div>
            <div className="text-right flex flex-col items-end">
              <Clock size={12} className="text-zinc-700 mb-1" />
              <span className="text-[9px] text-zinc-700">
                {new Date(convo.last_message_at).toLocaleDateString()}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
